import Message from "../../components/Message/Message";
import MessangerChatBox from "../../components/MessangerChatBox/MessangerChatBox";
import MessangerLeftBar from "../../components/MessangerLeftBar/MessangerLeftBar";
import MessangerRightBar from "../../components/MessangerRightBar/MessangerRightBar";
import Topbar from "../../components/topbar/Topbar";
import './Messanger.css';

function Messanger() {
    return (
        <>
            <Topbar />
            <div className="messanger">
                {/* <MessangerLeftBar/> */}
                {/* <MessangerChatBox/> */}
                {/* <MessangerRightBar/> */}
                <h1 style={{'textAlign':'center'}}>This page is under construction.</h1>
            </div>
        </>
    );
}

export default Messanger;